var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "work_inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61.000000, -177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.000000, 177.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0338342,18.225293 L15.1621762,18.225293 C15.571382,18.225293 15.9031088,18.5604078 15.9031088,18.9737929 L15.9031088,23.8533321 L18.1865285,23.8533321 L18.1865285,1.76918167 C18.1865285,1.61885981 18.0659006,1.49699987 17.9170984,1.49699987 L8.06134715,1.49699987 C7.91254504,1.49699987 7.7919171,1.61885981 7.7919171,1.76918167 L7.7919171,8.65538108 C7.7919171,8.68668199 7.7919171,8.71866335 7.7919171,8.75132516 L7.7919171,23.8533321 L10.292228,23.8533321 L10.292228,18.9737929 C10.2922279,18.7751604 10.3703827,18.5846734 10.5094802,18.4442828 C10.6485778,18.3038923 10.83721,18.2251124 11.0338342,18.225293 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.7747668 19.7222929 14.4212435 19.7222929 14.4212435 23.8540125 11.7747668 23.8540125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04129534,8.47914337 L1.75129534,8.47914337 C1.60249323,8.47914337 1.48186528,8.60100331 1.48186528,8.75132516 L1.48186528,23.8533321 L6.31005181,23.8533321 L6.31005181,8.74724244 C6.30784759,8.59878191 6.18827104,8.47949786 6.04129534,8.47914337 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7747668,19.7222929 L14.4212435,19.7222929 L14.4212435,23.8533321 L15.9031088,23.8533321 L15.9031088,18.9737929 C15.9031088,18.5604078 15.571382,18.225293 15.1621762,18.225293 L11.0338342,18.225293 C10.6246284,18.225293 10.2929016,18.5604078 10.2929016,18.9737929 L10.2929016,23.8533321 L11.7747668,23.8533321 L11.7747668,19.7222929 Z",
    fill: "#8C909E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9170984,0 L8.06134715,0 C7.09413344,-5.98296329e-17 6.31005181,0.792089613 6.31005181,1.76918167 L6.31005181,6.9821435 L1.75129534,6.9821435 C0.78408163,6.9821435 1.18449517e-16,7.77423311 0,8.75132516 L0,24.2616047 C7.28920105e-17,24.8628922 0.482511772,25.3503319 1.07772021,25.3503319 L18.5906736,25.3503319 C19.185882,25.3503319 19.6683938,24.8628922 19.6683938,24.2616047 L19.6683938,1.76918167 C19.6683938,0.792089613 18.8843122,5.98296329e-17 17.9170984,0 Z M6.31005181,23.8533321 L1.48186528,23.8533321 L1.48186528,8.75132516 C1.48186528,8.60100331 1.60249323,8.47914337 1.75129534,8.47914337 L6.04129534,8.47914337 C6.18801822,8.47911372 6.30779093,8.59768978 6.31072539,8.74588153 L6.31005181,23.8533321 Z M18.1865285,23.8533321 L7.79259067,23.8533321 L7.79259067,8.75132516 C7.79259067,8.71866335 7.79259067,8.68327971 7.79259067,8.65538108 L7.79259067,1.76918167 C7.79259067,1.61885981 7.91321862,1.49699987 8.06202073,1.49699987 L17.9170984,1.49699987 C18.0659006,1.49699987 18.1865285,1.61885981 18.1865285,1.76918167 L18.1865285,23.8533321 Z",
    fill: "#8C909E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 3.89663212,
    cy: 21.6922086,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    transform: "translate(3.895990, 18.202708) rotate(-13.280000) translate(-3.895990, -18.202708) ",
    cx: 3.89599022,
    cy: 18.202708,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    transform: "translate(3.896808, 14.711450) rotate(-45.000000) translate(-3.896808, -14.711450) ",
    cx: 3.89680816,
    cy: 14.7114504,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    transform: "translate(3.896890, 11.220728) rotate(-9.220000) translate(-3.896890, -11.220728) ",
    cx: 3.89688995,
    cy: 11.2207283,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 14.7203109,
    cy: 11.2206945,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 14.7203109,
    cy: 7.73064343,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 14.7203109,
    cy: 4.23991191,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 14.7203109,
    cy: 14.711426,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 11.4756995,
    cy: 14.711426,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 11.4756995,
    cy: 11.2206945,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 11.4756995,
    cy: 7.73064343,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 11.4756995,
    cy: 4.23991191,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0753368,23.8533321 L7.7919171,23.8533321 L7.7919171,1.76918167 C7.7919171,1.61885981 7.91254504,1.49699987 8.06134715,1.49699987 L17.9170984,1.49699987 C18.0659006,1.49699987 18.1865285,1.61885981 18.1865285,1.76918167 L18.1865285,8.65538108 C18.1865285,8.68668199 18.1865285,8.71866335 18.1865285,8.75132516 L18.1865285,23.8533321 L15.685544,23.8533321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2036788,23.8533321 L11.5572021,23.8533321"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9378238,8.47914337 L24.2278238,8.47914337 C24.3766259,8.47914337 24.4972539,8.60100331 24.4972539,8.75132516 L24.4972539,23.8533321 L19.6683938,23.8533321 L19.6683938,8.74724244 C19.6706024,8.59851739 19.7905858,8.47912663 19.9378238,8.47914337 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.685544,23.8533321 L14.2036788,23.8533321",
    fill: "#8C909E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5572021,23.8533321 L10.0753368,23.8533321",
    fill: "#8C909E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31005181,1.76918167 L6.31005181,24.2616047 C6.31005181,24.8628922 6.79256359,25.3503319 7.38777202,25.3503319 L24.9007254,25.3503319 C25.4959338,25.3503319 25.9784456,24.8628922 25.9784456,24.2616047 L25.9784456,8.75132516 C25.9784456,7.77423311 25.194364,6.9821435 24.2271503,6.9821435 L19.6683938,6.9821435 L19.6683938,1.76918167 C19.6683938,0.792089613 18.8843122,5.98296329e-17 17.9170984,0 L8.06134715,0 C7.09413344,-5.98296329e-17 6.31005181,0.792089613 6.31005181,1.76918167 Z M19.6683938,8.74588153 C19.6713282,8.59768978 19.791101,8.47911372 19.9378238,8.47914337 L24.2278238,8.47914337 C24.3766259,8.47914337 24.4972539,8.60100331 24.4972539,8.75132516 L24.4972539,23.8533321 L19.6683938,23.8533321 L19.6683938,8.74588153 Z M7.7919171,1.76918167 C7.7919171,1.61885981 7.91254504,1.49699987 8.06134715,1.49699987 L17.9170984,1.49699987 C18.0659006,1.49699987 18.1865285,1.61885981 18.1865285,1.76918167 L18.1865285,8.65538108 C18.1865285,8.68668199 18.1865285,8.71866335 18.1865285,8.75132516 L18.1865285,23.8533321 L7.7919171,23.8533321 L7.7919171,1.76918167 Z",
    fill: "#8C909E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    cx: 22.082487,
    cy: 21.6922086,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    transform: "translate(22.082147, 18.200399) rotate(-76.720000) translate(-22.082147, -18.200399) ",
    cx: 22.0821466,
    cy: 18.2003994,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    transform: "translate(22.082782, 14.711331) rotate(-45.000000) translate(-22.082782, -14.711331) ",
    cx: 22.0827816,
    cy: 14.7113307,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8C909E",
    fillRule: "nonzero",
    transform: "translate(22.083024, 11.221157) rotate(-80.780000) translate(-22.083024, -11.221157) ",
    cx: 22.0830238,
    cy: 11.2211565,
    rx: 1,
    ry: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkInactive);
export default __webpack_public_path__ + "static/media/work_inactive.c22342e7243c11d6ae1fdd349150c408.svg";
export { ForwardRef as ReactComponent };